export const entityServices = {
    createNewKey,
    removeDeletedEntity,
    removeDeletedScenario,
    insertNewSubEntity,
    insertNewScenario,
    updateUpdatedEntity,
    updateScenarioName,
    findEntityIDs,
};

function createNewKey(parent, newEntityStructure) {
    let oldKey = '';
    let key = '';

    if (parent === null && newEntityStructure.length === 0) {
        key = '0';
    } else if (parent === null && newEntityStructure.length > 0) {
        oldKey = newEntityStructure[newEntityStructure.length - 1].key;
        key = oldKey.slice(0, -1) + (+oldKey.slice(-1) + 1).toString();
    } else if (parent !== null && (!parent.scenario || parent.scenario.length === 0)) {
        key = parent.key + '.0';
        } else {
        const list = parent.scenario || [];
        oldKey = list[list.length - 1].key;
        key = oldKey.slice(0, -1) + (+oldKey.slice(-1) + 1).toString();
        }

    return key;
}

// --------------------------------------
// Remove an entity from the tree
// --------------------------------------
function removeDeletedEntity(deletedEntityId, entities) {
  if (!entities) return;

  if (Array.isArray(entities)) {
    for (let i = 0; i < entities.length; i++) {
      const entity = entities[i];

      if (entity.entity_id === deletedEntityId) {
        entities.splice(i, 1);
        return;
      }

      if (Array.isArray(entity.children)) {
        removeDeletedEntity(deletedEntityId, entity.children);
      }
    }
  } else {
    for (const key in entities) {
      const entity = entities[key];

      if (entity.entity_id === deletedEntityId) {
        delete entities[key];
        return;
      }

      if (Array.isArray(entity.children)) {
        removeDeletedEntity(deletedEntityId, entity.children);
      }
    }
  }
}

// --------------------------------------
// Remove a scenario from whichever entity owns it
// --------------------------------------
function removeDeletedScenario(deletedScenario, entities) {
  if (!entities) return;

  const scenarioId = deletedScenario.scenario_id;

  if (Array.isArray(entities)) {
    for (const entity of entities) {
      if (Array.isArray(entity.scenario)) {
        const idx = entity.scenario.findIndex(
          (s) => s.scenario_id === scenarioId
        );
        if (idx !== -1) {
          entity.scenario.splice(idx, 1);
          return;
        }
      }

      if (Array.isArray(entity.children)) {
        removeDeletedScenario(deletedScenario, entity.children);
      }
    }
  } else {
    for (const key in entities) {
      removeDeletedScenario(deletedScenario, entities[key]);
    }
  }
}

// --------------------------------------
// Insert a new *sub-entity* under its parent entity
// --------------------------------------
function insertNewSubEntity(newEntity, entities) {
  if (!entities) return;

  if (Array.isArray(entities)) {
    for (const entity of entities) {
      if (entity.entity_id === newEntity.parent) {
        if (!Array.isArray(entity.children)) {
          entity.children = [];
        }
        entity.children.push(newEntity);
        return;
      }

      if (Array.isArray(entity.children)) {
        insertNewSubEntity(newEntity, entity.children);
      }
    }
  } else {
    for (const key in entities) {
      const entity = entities[key];
      if (entity.entity_id === newEntity.parent) {
        if (!Array.isArray(entity.children)) {
          entity.children = [];
        }
        entity.children.push(newEntity);
        return;
      }

      if (Array.isArray(entity.children)) {
        insertNewSubEntity(newEntity, entity.children);
      }
    }
  }
}

// --------------------------------------
// Insert a new scenario into the correct entity.scenario[]
// --------------------------------------
function insertNewScenario(newScenario, entities) {
  if (!entities) return;

  const targetEntityId = newScenario.entity_id;

  if (Array.isArray(entities)) {
    for (const entity of entities) {
      if (entity.entity_id === targetEntityId) {
        if (!Array.isArray(entity.scenario)) {
          entity.scenario = [];
        }
        entity.scenario.push(newScenario);
        return;
      }

      if (Array.isArray(entity.children)) {
        insertNewScenario(newScenario, entity.children);
      }
    }
  } else {
    for (const key in entities) {
      const entity = entities[key];

      if (entity.entity_id === targetEntityId) {
        if (!Array.isArray(entity.scenario)) {
          entity.scenario = [];
        }
        entity.scenario.push(newScenario);
        return;
      }

      if (Array.isArray(entity.children)) {
        insertNewScenario(newScenario, entity.children);
      }
    }
  }
}

// --------------------------------------
// Update entity name (rename entity)
// --------------------------------------
function updateUpdatedEntity(updatedEntity, entities) {
  if (!entities) return;

  if (Array.isArray(entities)) {
    for (const entity of entities) {
      if (entity.entity_id === updatedEntity.entity_id) {
        entity.name = updatedEntity.name;
        return;
      }

      if (Array.isArray(entity.children)) {
        updateUpdatedEntity(updatedEntity, entity.children);
      }
    }
  } else {
    for (const key in entities) {
      updateUpdatedEntity(updatedEntity, entities[key]);
    }
  }
}

// --------------------------------------
// Update scenario name (rename scenario)
// --------------------------------------
function updateScenarioName(updatedScenario, entities) {
  if (!entities) return;

  const scenarioId = updatedScenario.scenario_id;

  if (Array.isArray(entities)) {
    for (const entity of entities) {
      if (Array.isArray(entity.scenario)) {
        for (const s of entity.scenario) {
          if (s.scenario_id === scenarioId) {
            s.name = updatedScenario.name;
            return;
          }
        }
      }

      if (Array.isArray(entity.children)) {
        updateScenarioName(updatedScenario, entity.children);
      }
    }
  } else {
    for (const key in entities) {
      updateScenarioName(updatedScenario, entities[key]);
    }
  }
}

// --------------------------------------
// Collect all entityIds + scenarioIds in the tree
// --------------------------------------
function findEntityIDs(ids, entities) {
  if (!entities) return;

  if (!ids.entityIds) ids.entityIds = [];
  if (!ids.scenarioIds) ids.scenarioIds = [];

  if (Array.isArray(entities)) {
    for (const entity of entities) {
      if (entity.entity_id != null) {
        ids.entityIds.push(entity.entity_id);
      }

      if (Array.isArray(entity.scenario)) {
        for (const s of entity.scenario) {
          if (s.scenario_id != null) {
            ids.scenarioIds.push(s.scenario_id);
          }
        }
      }

      if (Array.isArray(entity.children)) {
        findEntityIDs(ids, entity.children);
      }
    }
  } else {
    for (const key in entities) {
      findEntityIDs(ids, entities[key]);
    }
  }
}
